import { AngularLogBE } from './AngularLogBE';

export class AngularLogListBE {
    constructor() {}

    clientIP: string;
    registros: AngularLogBE[];
}